
export default {
  data() {
    return {};
  },
  computed: {
    active: function() {
      let list = ['/page/index', '/page/product', '/page/mine'];
      let path = this.$route.path;
      let index = list.findIndex( item => item == path);
      return index;
    }
  }
};
